// Patient-owned mobile bottom tab bar.
// APPROVED ORDER: Home | Records | Chat | NeoAI | Profile — "Appts" must NOT
// appear here (appointments stay reachable via Today's Care / Care Services /
// the appointments routes). Visually identical to the design-system NHCTabBar
// (same tokens), but owned by patient-web so the shared design system stays
// untouched (it is read-only reference for this module).
import { T } from '@design/index';

interface TabItem {
  key: string;
  label: string;
  icon: string;
}

const PATIENT_TABS: TabItem[] = [
  { key: 'home', label: 'Home', icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z' },
  { key: 'records', label: 'Records', icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6' },
  { key: 'chat', label: 'Chat', icon: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z' },
  { key: 'neoai', label: 'NeoAI', icon: 'M12 2a7 7 0 017 7c0 4-3 6-3 9H8c0-3-3-5-3-9a7 7 0 017-7z M9 21h6' },
  { key: 'profile', label: 'Profile', icon: 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2 M12 3a4 4 0 100 8 4 4 0 000-8z' },
];

interface Props {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function PatientTabBar({ activeTab, onTabChange }: Props) {
  const accent = T.teal; // patient role accent

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        padding: '8px 12px 4px',
        background: T.white,
        borderTop: `1px solid ${T.border}`,
        flexShrink: 0,
      }}
    >
      {PATIENT_TABS.map((tab) => {
        const active = tab.key === activeTab;
        return (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              background: 'none',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              padding: '4px 8px',
              cursor: 'pointer',
              fontFamily: T.font,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? accent : '#94A3B8'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d={tab.icon} />
            </svg>
            <span style={{ fontSize: 10, fontWeight: active ? 700 : 500, color: active ? accent : '#94A3B8' }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
